import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/Form';
import { Input } from '../components/PlayerUI';
import { IconButton } from '../components/UI';
import Button from '../components/Button';
import Icon from '../components/Icon';
import { useTheme } from '../context/ThemeContext';

type FaqItem = { question: string; answer: string };

export default function FAQ() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [query, setQuery] = useState('');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const items = t('faq.items', { returnObjects: true }) as FaqItem[];
  const filtered = useMemo(() => {
    const search = query.trim().toLowerCase();
    return search ? items.filter(item => `${item.question} ${item.answer}`.toLowerCase().includes(search)) : items;
  }, [items, query]);

  return (
    <main className="sls-page">
      <PageHeader title={t('faq.title')} right={<IconButton icon="arrow-left" accessibilityLabel={t('faq.back')} onPress={() => navigate(-1)} />} />
      <div className="sls-page-content">
        <Input label={t('faq.searchLabel')} placeholder={t('faq.searchPlaceholder')} value={query} onChange={event => setQuery(event.target.value)} type="search" />
        <div style={{ marginTop: 20 }}>
          {filtered.length ? filtered.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <section key={item.question} style={{ borderBottom: `1px solid ${colors.line}` }}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} style={{ width: '100%', minHeight: 64, display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', border: 0, background: 'transparent', color: colors.text, textAlign: 'left', fontSize: 16, fontWeight: 700 }}>
                  <span style={{ flex: 1 }}>{item.question}</span>
                  <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} size={14} color={colors.textMuted} />
                </button>
                {isOpen ? <p style={{ margin: '0 0 18px', color: colors.textSub, fontSize: 15, lineHeight: 1.55 }}>{item.answer}</p> : null}
              </section>
            );
          }) : <p style={{ margin: '28px 0', color: colors.textSub, fontSize: 16 }}>{t('faq.noResults')}</p>}
        </div>
        <div style={{ marginTop: 28 }}>
          <p style={{ color: colors.textSub, fontSize: 16 }}>{t('faq.stillNeedHelp')}</p>
          <Button label={t('faq.contact')} onClick={() => { window.location.href = `mailto:${t('auth.login.supportEmail')}`; }} />
        </div>
      </div>
    </main>
  );
}
